<template>
  <div class="tag-container">
    <svg width="200" height="100" id="tag-svg">
      <line 
        id="tag-stem" 
        x1="3" y1="97" x2="30" y2="50"
      ></line>
      <line 
        id="tag-top" 
        x1="31" y1="50" x2="196" y2="50"
      ></line>
    </svg>
    <div id="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FireflyTag',
  props: ['x', 'y'],
  computed: {
    top () {
      return `${this.y - 105}px`
    },
    left () {
      return `${this.x + 5}px`
    }
  },
  methods: {
    getLineLength (line) {
      const x1 = line.getAttribute('x1');
      const y1 = line.getAttribute('y1');
      const x2 = line.getAttribute('x2');
      const y2 = line.getAttribute('y2');

      // first part of distance equation
      const p1 = (x2 - x1) ** 2;
      // second part of distance equation
      const p2 = (y2 - y1) ** 2;

      const d = Math.sqrt(p1 + p2);

      return d
    },
    getStemLength () {
      const stem = document.getElementById('tag-stem');
      return this.getLineLength(stem)
    },
    getTopLength () {
      const top = document.getElementById('tag-top');
      return this.getLineLength(top)
    }
  }
}
</script>

<style scoped>
line {
  stroke: yellow;
  stroke-width: 4;
  stroke-linecap: round;
}

.tag-container {
  width: 200px;
  height: 100px;

  position: absolute;
  top: v-bind(top);
  left: v-bind(left);

  color: yellow;
}

#tag-stem {
  animation: stem-show .5s linear;
  stroke-dasharray: v-bind(getStemLength());
}

#tag-top {
  animation: top-show .5s linear;
  stroke-dasharray: v-bind(getTopLength())
}

#content {
  animation: content-show .5s linear;
  position: relative;
  top: -50px;
  left: 35px;
  overflow: hidden;
}

@keyframes stem-show {
  0% {
    stroke-dashoffset: v-bind(getStemLength());
  }
  30% {
    stroke-dashoffset: 0;
  }
}

@keyframes top-show {
  0%, 30% {
    stroke-dashoffset: v-bind(getTopLength());
  }
  80% {
    stroke-dashoffset: 0;
  }
}

@keyframes content-show {
  0%, 30% {
    width: 0px;
  }
  80% {
    width: 170px;
  }
}
</style>